module.exports = __webpack_public_path__ + "static/img/5-1.cbaea4e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/5-1.png
// module id = K5nr
// module chunks = 0